import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IFilterItem } from '@cbridge-tools/filters-panel';
import { ClientSymbolFilter } from '@cbridge-packages/symbol-client';

export const useSymbolMappingFilterItems = (isTradingAware: boolean): IFilterItem[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!isTradingAware) {
      return [];
    }

    return [
      {
        value: ClientSymbolFilter.NonTradable,
        label: t('text:entity.clientSymbol.filter.nonTradable'),
      },
    ];
  }, [t, isTradingAware]);
};
